import { Box, CircularProgress } from '@mui/material';

export default function LoadingFallback({ height = 240 }: { height?: number | string }) {
  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height }}
      role="status"
      aria-label="Loading"
    >
      <CircularProgress />
    </Box>
  );
}
